import styled from 'styled-components'

export const StyledBlock = styled.div`
  border-left-width: 3px;
  border-left-style: solid;
  border-left-color: var(--tds-information);
  border-radius: 4px;
  @media (min-width: ${({ theme }) => theme.size.md}) {
    height: 60px;
    display: flex;
    align-items: center;
  }
  @media (min-width: ${({ theme }) => theme.size.lg}) {
    height: 60px;
    display: flex;
    align-items: center;
  }
`

export const ServiceIcon = styled.div<{ positive: boolean }>`
  color: ${({ positive }) =>
    positive ? 'var(--tds-positive)' : 'var(--tds-negative)'};
  width: 20px;
  height: 20px;
  text-align: center;
  display: inline-block;
`

export const ServiceTable = styled.div.attrs({
  role: 'table'
})`
  display: table;
  width: 100%;
`

export const TableRowGroup = styled.div.attrs({
  role: 'rowgroup'
})`
  display: table-row-group;
`

export const TableRow = styled.div.attrs({
  role: 'row'
})`
  display: table-row;
  text-align: center;
`

export const TableHeader = styled.div.attrs({
  className: 'tds-detail-04',
  role: 'columnheader'
})`
  display: table-cell;
`

export const TableCell = styled.div.attrs({
  role: 'cell'
})`
  display: table-cell;
`
